import {DndContext, PointerSensor, TouchSensor, useSensor, useSensors} from '@dnd-kit/core';
import ProductShopList from 'components/Globals/Grids/ProductShopList';
import ProductsCategoryLayout from 'layouts/products/ProductsCategoryLayout';
import { useCart } from 'services/CartService';
import Cart from 'components/Globals/Cart/Cart';
import { useState } from 'react';
import { ShoppingBasket, Trash2 } from 'lucide-react';
import { Droppable } from 'components/Globals/Drop/Droppable';


export function ProductLayout() {
  const { addToCart, removeFromCart } = useCart();
  const [disabledCart, setDisabledCart] = useState(false)

  const sensors = useSensors(
    useSensor(PointerSensor), // Souris & trackpad
    useSensor(TouchSensor, { activationConstraint: { delay: 750, tolerance: 5 } }) // Gère le tactile
  );

  // function disableScroll() {
  //   document.body.style.overflow = "hidden"; // Bloque le scroll
  //   document.body.style.width = "100vw";
  // }
  
  // function enableScroll() {
  //   document.body.style.overflow = ""; // Réactive le scroll
  // }
  
  return (
    <div className='overflow-hidden'>
      <div className='hidden lg:block'>
        <DndContext
          sensors={sensors}
          onDragEnd={handleDragEnd} 
          onDragStart={(e) => e?.active?.data?.current?.fromCart ? setDisabledCart(true) : setDisabledCart(false)}
        >
          <div className={`relative ${disabledCart ? 'z-10' : 'z-30'} w-[calc(100vw-300px)] pt-[57px]`}>
            {disabledCart &&
              <div 
                style={{backgroundColor: 'rgba(255, 99, 71, 0.7)'}}
                className='
                  w-[calc(100vw-300px)] 
                  h-[calc(100vh-68px)] 
                  border-2 
                  border-destructive 
                  border-dashed 
                  rounded-xl 
                  flex 
                  flex-col
                  justify-center 
                  items-center 
                  fixed 
                  left-0 
                  top-[68px]
                  z-20
                '
              >
                <Trash2 size={70} className='text-gray-200 mb-5' />
                <p className='text-3xl text-gray-200 font-bold'>Supprimer</p>
              </div>
            }
            <div className='container relative z-10 pt-3 px-8 min-h-[calc(100vh-57px)]'>
              <ProductsCategoryLayout />
              <ProductShopList />
            </div>
          </div>
          <div className='flex fixed left-0 top-[57px] h-[calc(100vh-57px)] z-20 justify-end w-full'>
            <div className={`realtive h-full flex flex-col bg-[#F9F4E7] z-30 w-[300px]`}>
              <Cart disabledCart={disabledCart} />
            </div>
          </div>
        </DndContext>
      </div>

      {/* LITTLE SCREEN */}
      <div className={`lg:hidden`}>
        <DndContext
          sensors={sensors} 
          onDragEnd={handleDragEnd} 
          onDragStart={() => {
            setDisabledCart(true)
          }}
        >
          <div className={`relative pt-[57px]`}>
            <div className='container relative z-10 pt-3 min-h-[calc(100vh-57px)]'>
              <ProductsCategoryLayout />
              <ProductShopList />
            </div>
          </div>

          <div className={`fixed left-0 h-32 w-full rounded-t-3xl z-20 overflow-hidden transition-all delay-150 duration-200 ease-in-out ${disabledCart ? 'bottom-0' : '-bottom-32'}`}>
            <Droppable fromMobile>
              <div className='flex flex-col items-center justify-center h-full'>
                <ShoppingBasket className='text-white mb-2' size={45} />
                <p className='text-white text-xl font bold'>Ajouter dans le panier</p>
              </div>
            </Droppable>
          </div>
        </DndContext>
      </div>
    </div>
  );
  
  function handleDragEnd(event:any) {
    if (!event.active.data.current.fromCart) {
      if (event.over && event.over.id === 'Cart') {
        addToCart(event.active.data.current.productId, 1, true);
      } 
    } else {
      if (!event.over) {
        removeFromCart(event.active.data.current.productId, event.active.data.current.quantity);
      }
    }
    setDisabledCart(false)
    // enableScroll()
  }
}